import React, { Component } from 'react';
import MineralUiGrid, { GridItem as MineralUiGridItem } from 'mineral-ui/Grid';

// Wrapper for MineralUi grid components
// https://mineral-ui.com/components/grid

export default class Grid extends Component {
  static Item = MineralUiGridItem;

  render() {
    return <MineralUiGrid {...this.props} />;
  }
}
